export default "__VITE_ASSET__BptI16_3__"